import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/buildhome/repo/web-app/frontend/node_modules/lucide-react/dist/esm/Icon.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/buildhome/repo/web-app/frontend/src/components/FaqList.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/buildhome/repo/web-app/frontend/src/components/SharedHeader.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/buildhome/repo/web-app/frontend/src/lib/localized-link.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/buildhome/repo/web-app/frontend/src/lib/nav-link.tsx");
